export const suppressEmotionFirstChildSelectorWarning =
  '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';

const emotionFirstChildSelector = `:first-child ${suppressEmotionFirstChildSelectorWarning}`;

export default emotionFirstChildSelector;
